import { useState, useContext, useEffect, useMemo } from 'react'
import { FronthubContext } from 'front-hub-context-api'
import grants from '../../authorization-api/grants'
import { isPromise } from '../../../../core/object'
import Authorizer from './authorizer'
import withHostContext from '../with-host-context'

export default function useAuthorization() {
  const { rbac: lazyRBAC } = useContext(FronthubContext)
  const [rbacAvailable, setRBACAvailable] = useState()

  useEffect(() => {
    let cancel

    if (isPromise(lazyRBAC)) {
      cancel = lazyRBAC.then(rbac => {
        setRBACAvailable({
          ...grants(rbac || {}),
          role: rbac.role,
        })
      }).cancel
    }

    return cancel
  }, [])

  const Component = withHostContext(Authorizer(rbacAvailable))
  Component.Allowed = withHostContext(Authorizer(rbacAvailable))
  Component.displayName = 'Allowed'
  Component.Allowed.displayName = Component.displayName
  Component.Denied = withHostContext(Authorizer(rbacAvailable, false))
  Component.Denied.displayName = 'Denied'

  return useMemo(() => Component, [rbacAvailable])
}
